import { createContext } from 'react';

const MeuConsumptionContext = createContext();

export default MeuConsumptionContext;